import { Link } from '@chegg-ui/link'
import { Config } from '@chegg-wt/core/config'
import { BibliographyUpsellCopy } from '@chegg-wt/core/types/features'
import { BibliographyB1Copy } from '@chegg-wt/core/types/copy'

export const upsellCopy: BibliographyUpsellCopy = {
  plagiarism: {
    UPSELL_HEADING: 'Writing help from start to finish',
    CTA_COPY: 'Try Citation Machine Plus*',
    FEATURE_LIST: [
      'Unlimited plagiarism & grammar checks',
      'Summarized feedback from writing experts',
      '7,000+ styles including APA & Chicago',
    ],
    IMAGE_ALT_TEXT: 'plagiarism detected paper',
  },
  expertProofRead: {
    UPSELL_HEADING: 'Expert proofreading for papers',
    CTA_COPY: 'Try Expert Check',
    FEATURE_LIST: [
      'Get personalized comments on your main idea, conclusion & more',
      'Detailed feedback returned within 24 hours',
      '3-day free trial*',
    ],
    IMAGE_ALT_TEXT: 'plagiarism detected paper',
  },
}

export const bibliographyB1: BibliographyB1Copy = {
  title: 'Want to Learn More?',
  contents: [
    {
      header: 'Trouble with Citations?',
      body: () => (
        <div>
          Get the scoop on citation basics and how to cite different sources in MLA, APA,
          and Chicago formats with our&nbsp;
          <Link href={`${Config.baseUrl}/resources`}>citation guides here</Link>.
        </div>
      ),
    },
    {
      header: 'Teacher Wants Annotations?',
      body: () => (
        <div>
          Annotations are a great way to add a summary of your personal thoughts about a
          source. To include yours, go to the citation form and fill out the &quot;Add
          Annotation&quot; field.
        </div>
      ),
    },
    {
      header: 'Evaluated Your Sources?',
      body: () => (
        <div>
          Your teacher will be looking at the kind of sources that were cited. Take a
          moment to think about the credibility of your sources before using them in your
          paper or project.
        </div>
      ),
    },
    {
      header: 'Done Writing?',
      body: () => (
        <div>
          Make a title page! The topper on your awesome, finished paper should be a
          perfectly formatted title page. Here&apos;s a&nbsp;
          <Link href={`${Config.baseUrl}/title-page`}>title page tool</Link>
          &nbsp;to help you make one!.
        </div>
      ),
    },
    {
      header: 'Check for Plagiarism, yet?',
      body: () => (
        <div>
          Head off problems before your teacher catches them. Try our&nbsp;
          <Link href={`${Config.baseUrl})}/grammar-and-plagiarism/`}>
            plagiarism checking tool
          </Link>
          &nbsp;today!
        </div>
      ),
    },
    {
      header: 'Need In-text Citations?',
      body: () => (
        <div>
          Whether your teacher is asking for parenthetical citations or footnotes, we have
          you covered with our in-text citation tools. Access it by clicking the
          &quot;parenthetical&quot; or &quot;footnote&quot; link under the appropriate
          citation.
        </div>
      ),
    },
    {
      header: 'Unsure What Citation Form to Use?',
      body: () => (
        <div>
          Creating a citation starts with knowing what kind of source you&apos;re citing.
          We have citation forms for over 50 different source types! Click
          &quot;Other&quot; to see the options.
        </div>
      ),
    },
    {
      header: 'What’s Autocite?',
      body: () => (
        <div>
          With Autocite, you tell us a little about your source and we try to search for
          and find the information you need to cite it. It’s very easy and can be used
          with 22 different source types!
        </div>
      ),
    },
    {
      header: 'Need a different citation style?',
      body: () => <div>Look no further! Choose from APA, MLA, or Chicago.</div>,
    },
  ],
}
